import React from 'react'
import './Wgbs.css'
import ideation from '../../../../assets/img/ideation.svg'
import cca from '../../../../assets/img/cca.svg'
import iud from '../../../../assets/img/iud.svg'
import dp from '../../../../assets/img/dp.svg'
import rt from '../../../../assets/img/rt.svg'
import deployment from '../../../../assets/img/deployment.svg'
import sam from '../../../../assets/img/sam.svg'
import { FaChevronRight } from 'react-icons/fa6'

function Wgbs() {
  
    const wgbslist = [
        {
            icon: ideation,
            title: "Ideation",
            desc: "The journey begins with creative idea generation, brainstorming sessions, and thorough validation to ensure the viability of concepts. At 360 Bytes, we believe that every great project starts with a solid foundation of innovative ideas."
        },
        {
            icon: cca,
            title: "Conducting Competitive Analysis",
            desc: "Our team conducts a comprehensive competitive analysis, gathering relevant information and market insights. This stage helps us formulate a well-structured strategy tailored to your business goals."
        },
        {
            icon: iud,
            title: "Intuitive UI/UX Design",
            desc: "Next, we focus on creating a visually appealing and user-centric interface with intuitive navigation. Our goal is to effectively convey your brand's message while ensuring an engaging and seamless user experience."
        },
        {
            icon: dp,
            title: "Development Phase",
            desc: "As a reputable web app development company, 360 Bytes dedicates itself to crafting responsive and custom web applications that precisely align with our client's specific requirements. Our development phase ensures that the final product meets the highest standards of performance and functionality."
        },
        {
            icon: rt,
            title: "Robust Testing",
            desc: "Our skilled team conducts rigorous testing at various stages to ensure the final web application is error-free and glitch-free. We prioritize delivering a seamless user experience, ensuring that your application functions flawlessly."
        },
        {
            icon: deployment,
            title: "Deployment",
            desc: "After meticulous testing, our developers launch the web app, ensuring a smooth and efficient deployment process. We manage every aspect of the deployment to guarantee a successful launch."
        },
        {
            icon: sam,
            title: "Support and Maintenance",
            desc: "Next, we focus on creating a visually appealing and user-centric interface with intuitive navigation. Our goal is to effectively convey your brand's message while ensuring an engaging and seamless user experience."
        },
    ]

  return (
    <section className='wgbs-sec'>
        <div className='container'>
            <h3>How Exactly Do  </h3>
            <h4>We Help With Marketing?</h4>
            <h5>Pre-Launch Marketing</h5>
            <p className='plg'>Our experts research your target audience and competitors to craft effective pre-launch campaigns, increasing your app's launch success.</p>
            <p className='plg'>Boost your app's visibility and engagement with our post-launch marketing strategies, combined with ASO best practices to ensure more installs and revenue growth.</p>
            <h5>What Factors Should You Consider While Choosing The Right Platform For App Development?            </h5>
            <p>Understand your target audience’s preferences, demographics, and device usage habits to determine whether to develop for iOS, Android, or both platforms. Evaluate the features and functionality you want your app to offer and determine whether certain platforms support those capabilities better than others. Assess the development costs, maintenance overhead, and potential revenue generation of each platform to make informed decisions aligned with your budget and business objectives.To ensure successful app development, it's crucial to understand your target audience. Analyze their preferences, demographics, and device usage patterns to determine whether iOS, Android, or both platforms align with their needs. Evaluate the features and functionalities you want your app to offer, considering which platforms support them optimally. Assess the development costs, ongoing maintenance requirements, and potential revenue generation of each platform. By making informed decisions based on these factors, you can align your app's development with your budget and business objectives, increasing its chances of success.
            </p>
            {/* <ul>
                {
                    wgbslist.map((Wgbs, index)=>(
                        <li key={index}>
                            <h6> <span className='wgbs-icon'><img src={Wgbs.icon} alt=''/></span> <span className='wgbs-head'>{Wgbs.title}</span></h6>
                            <p>{Wgbs.desc}</p>
                        </li> 
                    ))
                }
                
            </ul> */}
            <button className='btn-main' onClick={() => window.location.href = '/contact'}><span>Contact Us</span> <FaChevronRight/></button>
        </div>

    </section>
  )
}

export default Wgbs
